import { Type, type Static } from '@sinclair/typebox';
import { ListResponseSchema } from '../../shared/utils/list-response.schema';
import { CalendarSchema } from './calendar.schema';

export const GetCalendarsListResponseSchema = ListResponseSchema(CalendarSchema);

export const GetCalendarResponseSchema = CalendarSchema;

export const CreateCalendarResponseSchema = CalendarSchema;

export const UpdateCalendarResponseSchema = CalendarSchema;

export const DeleteCalendarResponseSchema = Type.Null();

export type GetCalendarsListResponse = Static<typeof GetCalendarsListResponseSchema>;
export type GetCalendarResponse = Static<typeof GetCalendarResponseSchema>;
export type CreateCalendarResponse = Static<typeof CreateCalendarResponseSchema>;
export type UpdateCalendarResponse = Static<typeof UpdateCalendarResponseSchema>;
export type DeleteCalendarResponse = Static<typeof DeleteCalendarResponseSchema>;
